import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import parsePhoneNumber from 'libphonenumber-js'
import toastr from 'toastr';

import EmojiTextArea from "../common/EmojiTextArea";

// import ReactGA from "react-ga";
import countries from '../common/countries';
import credits from '../common/credits.json';

import RetinaImage from "react-retina-image";
import ContentEditableTextarea from "../common/ContentEditableTextarea";
import UpsellModalTailwind from "../modals/UpsellModalTailwind";
import TopUpModal from "../modals/TopUpModal";
import ChartLoader from "../utils/chart-loader";
import {MenuItem, Tag} from "@blueprintjs/core";
import {MultiSelect} from "@blueprintjs/select";
import * as authService from "../../services/authService";

class SMSInbox extends Component {

    state = {
        user: this.props.user,
        credits: credits,
        messageContent: '',
        navigation: 1,
        chatOpen: false,
        countries: countries,
        personalize: 0,
        selectedSource: this.props.selectedSource,
        sourcePlan: this.props.selectedSourceNode && this.props.selectedSourceNode.plan ? this.props.selectedSourceNode.plan.planId : '',
        selectedSourceFull: '',
        selectedSourceNode: this.props.selectedSourceNode,
        filterButton: false,
        cursorPosition: 0,
        chatInfoOpen: window.innerWidth > 764,
        isOpen: false,
        selectedChannel: 'SMS',
        selectedTags: [],
        chatInfoData: {
            name: '', phone: '', email: ''
        },

        smsConversations: [],
        selectedConversation: '',
        selectedConversationContact: '',
        selectedConversationFull: '',
        selectedConversationNo: '',
        messageHTML: '',
        personalizeParameters: '',

        //modal parameters
        upgradeModalActive: false,
        upgradeModalTitle: '',
        upgradeModalContent: '',

        //button handling
        loading: false,
        topUpModalOpen: false,
        messagesCost: {
            inboundMessage: 0, outboundMessage: 0
        },
        conversationCountryCode: '',
        callAvailable: true,
        loadingConversations: true
    };
    handleMessageUpdate = (html, message) => {
        if (message === undefined) {
            message = html
        }
        //console.log('message: ', message)
        let personalizationNotice = false
        let personalizeParameters = []

        if (message.includes('{first_name}')) {
            personalizationNotice = true
            if (!personalizeParameters.includes("first_name")) {
                personalizeParameters = [...personalizeParameters, "first_name"]
            }
        }
        if (message.includes('{last_name}')) {
            personalizationNotice = true

            if (!personalizeParameters.includes("last_name")) {
                personalizeParameters = [...personalizeParameters, "last_name"]
            }
        }
        if (message.includes('{full_name}')) {
            personalizationNotice = true

            if (!personalizeParameters.includes("full_name")) {
                personalizeParameters = [...personalizeParameters, "full_name"]
            }
        }

        this.setState({
            messageContent: message,
            messageHTML: html,
            personalizeParameters,
            personalize: personalizeParameters.length > 0 ? 1 : 0
        })
    }
    toggleMenu = () => {
        if (this.state.isOpen === false) {
            this.setState({
                isOpen: true
            })
        } else {
            this.setState({
                isOpen: false
            })
        }
    }
    tagSelect = async (item) => {

        let selectedTagIds = [];
        ////console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        ////console.log('selected tags ids:', selectedTagIds);
        if (selectedTags.includes(item) === false) {

            selectedTags.push(item);
            await this.setState({selectedTags: selectedTags});
        } else {
            const newTags = await selectedTags.filter(t => t !== item);
            await this.setState({selectedTags: newTags})
        }

        this.state.selectedTags.map(tag => {
            selectedTagIds = [...selectedTagIds, tag.id]
        });
        this.saveTags()
    };

    handleTagRemove = async (item) => {


        let selectedTagIds = [];
        ////console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;

        //console.log('item: ', item)
        // //console.log('selected tags:', selectedTags);
        // //console.log('item', item);
        // //console.log('itemId:', item.key);

        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);
        const tagsToRemove = await selectedTags.filter(t => t.tag === item.props.children);


        let subscriberIds = []
        subscriberIds.push(this.state.selectedConversation.contact.id)

        // console.log('subscriberIds: ', subscriberIds)
        // console.log('newTags: ', newTags);
        // console.log('tagsToRemove: ', tagsToRemove);
        // console.log('selectedTagIds -  remove: ', selectedTagIds);

        try {
            // console.log('id :', id);
            // console.log('subscriber ids:', this.state.checkedSubscribers);
            let result = await http.post('api/project/' + this.state.selectedSource + '/contacts_tags_remove/type/import_contacts/page_size/' + '10' + '?page=' + '1', {
                tag_ids: [tagsToRemove], subscriber_ids: subscriberIds
            }, {headers: {authorization: authService.getJwt()}});

            // console.log('partial response: ', data);
            await this.setState({selectedTags: newTags});
            toastr.success('Tag removed from contact.')
        } catch (err) {
            toastr.error(err)
        }


    };

    tagRender = (item) => {


        // //console.log('tag render item:', item);
        // //console.log('')
        return (<Tag key={item.id}>{item.tag}</Tag>)
        // //console.log('tag render end');
    };

    saveTags = async () => {
        let subscriberIds = []
        subscriberIds.push(this.state.selectedConversation.contact.id)
        // console.log('subscriberIds: ', subscriberIds)
        let tagIds = []

        this.state.selectedTags.map(tag => {
            tagIds.push(tag.id)
        })

        // console.log('tagIds:', tagIds)
        try {
            const result = await http.post('api/project/' + this.state.selectedSource + '/contacts_tags/type/import_contacts/page_size/' + '10' + '?page=' + 1, {
                tag_ids: tagIds, subscriber_ids: subscriberIds
            }, {headers: {authorization: authService.getJwt()}});
            // console.log('result: ', result)

            toastr.success('Tags successfully applied to contact.')
        } catch (err) {
            toastr.error(err)
        }

    }

    filterTags = (item) => {

        ////console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };
    sendSMSMessage = async () => {
        //console.log('send message started')
        this.setState({
            loading: true
        })

        let messageContent = this.state.messageContent

        // console.log('messageContent: ', messageContent)
        let countryCodes = []


        //console.log('countryCodes: ', countryCodes)

        //extracting country codes from 'from' and 'to' numbers
        const phoneNumberFrom = await parsePhoneNumber(//'+12025550134',
            this.state.selectedConversationFull[0].to, 'defaultCallingCode')

        let fromCountry = ''
        if (phoneNumberFrom) {
            // console.log('phoneNumberFrom: ', phoneNumberFrom)
            // console.log('phoneNumberFromCode: ', '+' + phoneNumberFrom.countryCallingCode)
            fromCountry = phoneNumberFrom.country
        }

        const phoneNumberTo = parsePhoneNumber(this.state.selectedConversationFull[0].from, //'+18769686796',
            'defaultCallingCode')

        let toCountry = ''
        if (phoneNumberTo) {
            // console.log('phoneNumberTo: ', phoneNumberTo)
            // console.log('phoneNumberToCode: ', '+' + phoneNumberTo.countryCallingCode)
            toCountry = phoneNumberTo.country
        }

        //console.log(fromCountry + ' + ' + toCountry)
        countries.find(country => {
            if (country.code === fromCountry || country.code === toCountry) {
                countryCodes.push(country.dial_code)
            }
        })

        // console.log('countryCodes after: ', countryCodes)
        let sendMessage = ''

        //console.log('selectedConversationFull[0]: ', this.state.selectedConversationFull[0])


        let data = {
            "message": messageContent,
            "from": this.state.selectedConversationFull[0].to,
            "to": this.state.selectedConversationFull[0].from,
            "country_codes": countryCodes
        }

        try {
            sendMessage = await http.post('/api/user/' + this.state.user.id + '/project/' + this.state.selectedSource + '/sms_direct_conversation', data, {headers: {authorization: getJwt()}});
        } catch (e) {
            toastr.error('SMS message sending failed.')
            //console.log('send sms error: ', e)
        }
        let reverseConversations = this.state.selectedConversationFull
        if (sendMessage) {
            //console.log('smsMessage response content: ', sendMessage)

            if (sendMessage.status === 200) {
                this.setState({
                    messageContent: ''
                })
            }

            await this.handleSelectChat(reverseConversations, true);
            //  console.log('document.getElementById("sms").value: ', document.getElementById("sms").value)
            //  console.log('document.getElementById("sms-mobile").value: ', document.getElementById("sms-mobile").value)

        } else {
            toastr.error('SMS message sending failed.')
            this.setState({
                topUpModalOpen: true
            })
        }
        // console.log('sendMessage: ', sendMessage)
        this.setState({
            loading: false
        })
    }
    multiMenuItem = (item, {modifiers, handleClick}) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}
                />

            )
        } else {
            return (<MenuItem
                className='multiselect-menu-item'
                icon='small-tick'
                active={modifiers.active}
                key={item.id}
                label=''
                text={item.tag}
                onClick={handleClick}
                shouldDismissPopover={true}
            />)
        }
    };
    closeTopUpModal = () => {
        this.setState({topUpModalOpen: false})
    }
    handleSmsFallbackMessage = (message) => {

        this.setState({
            messageContent: message,

        })
    }
    componentDidMount = async () => {
        //console.log('cdm started')
        //console.log('window.screen: ', window.innerWidth)
        //this.scrollToBottom()
        this.setState({
            loadingConversations: true
        })
        let selectedSourceFull = await this.state.user.sources.data.filter(source => {
            // //console.log('current source Id : ', source.id)
            // //console.log('selectedSource id :', this.state.selectedSource);
            return source.id.toString() === this.state.selectedSource.toString()

        })
        let userId = this.state.user.id

        let smsConversations = ''

        try {
            //console.log('called in CDM')
            //  console.log('CDM sms conversations call')
            smsConversations = await http.get('/api/user/' + userId + '/project/' + this.state.selectedSourceNode.id + '/sms_conversations', {headers: {authorization: getJwt()}})
        } catch (e) {
            //  console.log('smsConversations error: ', e)
        }

        //  console.log('smsConversations: ', smsConversations)
        this.setState({
            selectedSourceFull, sourcePlan: selectedSourceFull[0] ? selectedSourceFull[0].platforms[0].plan : '',
        })
        if (smsConversations !== '') {
            this.setState({
                smsConversations: smsConversations.data.conversations, loadingConversations: false
            })
        }
    }

    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            let selectedSourceFull = await this.state.user.sources.data.filter(source => {
                // //console.log('current source Id : ', source.id)
                // //console.log('selectedSource id :', this.state.selectedSource);
                return source.id.toString() === this.props.selectedSource.toString()

            })

            await this.setState({
                selectedSource: this.props.selectedSource,
                selectedSourceFull,
                sourcePlan: this.props.selectedSourceNode.plan ? this.props.selectedSourceNode.plan.plan_id : '', //loadingConversations: false
            })

        }
        if (this.state.selectedSourceNode !== this.props.selectedSourceNode) {

            let smsConversations = ''
            if (this.props.selectedSourceNode && this.state.callAvailable) {
                await this.setState({callAvailable: false})
                try {

                    //console.log('called in CDU')
                    smsConversations = await http.get('/api/user/' + this.state.user.id + '/project/' + this.props.selectedSourceNode.id + '/sms_conversations', {headers: {authorization: getJwt()}})
                } catch (e) {
                    // console.log('CDU smsConversations error: ', e)
                }
                await this.setState({
                    selectedSourceNode: this.props.selectedSourceNode,
                })
                if (smsConversations !== '') {
                    await this.setState({
                        smsConversations: smsConversations.data.conversations,
                        callAvailable: true,
                        loadingConversations: false
                    })
                }
            }
        }
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView();
        this.messagesMobileEnd.scrollIntoView();
    }

    handleSelectChat = async (fullConversation, sentMessage) => {
        //console.log('chat id: ', id)
        // let element = document.getElementById("chat-messages-container");
        // console.log('element: ', element)
        // console.log('element.scrollHeight: ', element.scrollHeight)
        // element.scrollTop = element.scrollHeight;
        // console.log('fullConversation: ', fullConversation)


        let incomingMessageFree;
        //console.log('selectedSourceFull: ', this.state.selectedSourceFull)
        if (this.state.selectedSourceFull[0].use_custom_plan === 1 && this.state.selectedSourceFull[0].custom_plan) {

            incomingMessageFree = this.state.selectedSourceFull[0].custom_plan.incoming_sms_free
        } else {
            incomingMessageFree = this.state.selectedSourceFull[0].plan.incoming_sms_free
        }
        //console.log('incomingMessageFree: ', incomingMessageFree)
        let conversation = fullConversation[0]

        // console.log('conversation: ', conversation)
        let selectedConversationCountryData = ''
        let conversationMessagesCostData = ''
        let contactId = ''
        if (!sentMessage) {
            selectedConversationCountryData = this.state.countries.find(country => {
                return (country.code === conversation.contact.country_code)
            })
            contactId = conversation.contact.id
        } else {
            contactId = this.state.selectedConversationContact.id
        }
        let conversationCountryCode = ''
        if (conversation?.contact?.country_code) {
            conversationCountryCode = conversation.contact.country_code
            await this.setState({
                conversationCountryCode
            })
        } else {
            conversationCountryCode = this.state.conversationCountryCode
        }
        //console.log('conversation: ', conversation)
        if (conversationCountryCode) {
            //console.log('conversationCountryCode: ', conversationCountryCode)
            conversationMessagesCostData = this.state.credits.prices_per_country.find(creditsData => {
                //console.log('creditsData: ', creditsData)
                return creditsData.country_iso === conversationCountryCode
            })


            //console.log('conversationMessagesCostData: ', conversationMessagesCostData)


            let messagesCost = {
                inboundMessage: '', outboundMessage: ''
            }

            // console.log('conversationsMessagesCostData: ', conversationMessagesCostData)
            if (Number(incomingMessageFree) === 1) {
                messagesCost.inboundMessage = 0
                messagesCost.outboundMessage = conversationMessagesCostData.sms_credit ? conversationMessagesCostData.sms_credit : ''
            } else {
                messagesCost.inboundMessage = conversationMessagesCostData.sms_credit ? conversationMessagesCostData.sms_credit : ''
                messagesCost.outboundMessage = conversationMessagesCostData.sms_credit ? conversationMessagesCostData.sms_credit : ''
            }

            //    console.log('selectedConversationCountryData: ', selectedConversationCountryData)
            let selectedConversationData = ''

            try {
                //console.log('called in handleSelectedChat')
                selectedConversationData = await http.get('/api/user/' + this.state.user.id + '/project/' + this.state.selectedSource + '/sms_conversations_for_contact/' + contactId, {headers: {authorization: getJwt()}})

            } catch (e) {
                //   console.log('getAllConvoMessages error: ', e)
            }
            // console.log('selectedConversationFull: ', selectedConversationData)
            let revConversations = selectedConversationData.data.conversations.reverse()
            let selectedTags = selectedConversationData.data.contact.tags
            // console.log('selectedTags: ', selectedTags)
            if (selectedConversationData) {
                if (!sentMessage) {
                    await this.setState({
                        selectedConversationFull: revConversations,
                        selectedConversationContact: selectedConversationData.data.contact,
                        selectedConversation: conversation,
                        selectedConversationNo: conversation.from,
                        selectedConversationCountryData,
                        messagesCost,
                        selectedTags
                    })
                } else {

                    //   console.log('handleSelectChat')
                    await this.setState({
                        selectedConversationFull: revConversations, messageContent: ''
                    })
                    document.getElementById("sms").value = "";
                    document.getElementById("sms").innerHTML = "";
                    document.getElementById("sms").innerText = "";
                    document.getElementById("sms-mobile").value = "";
                    document.getElementById("sms-mobile").innerHTML = "";
                    document.getElementById("sms-mobile").innerText = "";

                }
            }
            await this.scrollToBottom()
        }
    }

    closeChat = () => {
        this.setState({
            selectedConversationNo: ''
        })
    }
    handleChatInfo = () => {
        let chatInfoOpen = !this.state.chatInfoOpen
        this.setState({
            chatInfoOpen
        })
    }
    onlySpaces = (str) => {
        return str.trim().length === 0;
    }

    render() {
        let smsConversations = this.state.smsConversations
        //console.log('render -> smsConversations: ', smsConversations)

        return (<React.Fragment>
            <h1 id='unified-inbox-title' className='main-title'>SMS Inbox</h1>
            {


                this.state.loadingConversations ? <ChartLoader/> : smsConversations.length !== 0 ? <React.Fragment>
                    <div className="sms-inbox-container">


                        <React.Fragment>
                            <div className="display-flex unified-messenger-container">
                                <div
                                    className={this.state.selectedConversationNo === '' ? "chat-selector" : 'chat-selector chat-selected'}>

                                    <div className="select-chat">

                                        {Object.keys(smsConversations).map((key, index) => {
                                            return (<div id={key} key={index}
                                                         onClick={() => this.handleSelectChat(smsConversations[key], false)}
                                                         className={`single-chat ${this.state.selectedConversationNo === key ? 'active-chat' : ''}`}
                                            >
                                                <div className="display-flex single-chat-info">
                                                    {/*<img*/}

                                                    {/*    src="/img/default-user.jpg"*/}
                                                    {/*    alt="chat-1"/>*/}
                                                    <div className="number-preview-container">
                                                        <div className="number-date-container">
                                                                                <span className='text-bold'>

                                                                                    {smsConversations[key][0].contact.name && smsConversations[key][0].contact.name !== null && !this.onlySpaces(smsConversations[key][0].contact.name) ? smsConversations[key][0].contact.name : smsConversations[key][0].contact.phone}                                                                    </span>
                                                            <span className="chat-date">
                                                                                    {this.props.isoToDate(smsConversations[key][0].created_at)}
                                                                                </span>
                                                        </div>
                                                        <div
                                                            className="chat-excerpt">{smsConversations[key][0].message}</div>
                                                    </div>

                                                </div>
                                            </div>)


                                        })

                                        }


                                    </div>
                                </div>

                                {this.state.selectedConversationNo === '' ?
                                    <div className='messages-panel no-chat-selected'>
                                        <img className='margin-bottom-20' src="/img/no-chat-selected.png"
                                             alt="no-chat-selected"/>
                                        <p className='f-16 text-bold margin-bottom-20'>No chats
                                            selected.</p>
                                        <p>Select one from the queue to start
                                            chatting.</p>
                                    </div>

                                    : <div
                                        className={this.state.selectedConversationNo === '' ? "messages-panel " : 'messages-panel chat-selected'}>

                                        <div
                                            className={this.state.chatInfoOpen ? 'shrinking-part' : 'shrinking-part full-width'}>

                                            <div>

                                                <div className="messages-panel-settings">
                                                    <div className="selected-chat-info">
                                                        <i onClick={this.closeChat}
                                                           className="fas fa-chevron-left"></i>
                                                        {/*<img src="/img/default-user.jpg" alt="chat-pic"/>*/}
                                                        {this.state.selectedConversationContact.name ? <span
                                                            className='selected-chat-name text-bold'>{this.state.selectedConversationContact.name}</span> : ''

                                                        }
                                                        {this.state.selectedConversationContact.phone ?

                                                            <span
                                                                className='selected-chat-phone text-bold grey-text'>
                                                                        {this.state.selectedConversationContact.phone}</span> : ''}


                                                    </div>
                                                    <div className="selected-chat-settings">
                                                        {/*<i className="far fa-check-circle"></i>*/}
                                                        {/*<i className="fas fa-mail-bulk"></i>*/}

                                                        {/*<i className="fas fa-ellipsis-v"></i>*/}
                                                        <i
                                                            onClick={this.handleChatInfo}
                                                            className=
                                                                {this.state.chatInfoOpen ? "fas fa-info-circle blue-text" : "fas fa-info-circle"}
                                                        ></i>

                                                    </div>
                                                </div>
                                                <div
                                                    className="messages-panel-country display-flex justify-content-space">
                                                    <div className="country-container">
                                                                <span
                                                                    className='country-flag'>{this.state.selectedConversationCountryData ? this.state.selectedConversationCountryData.flag : ''}</span>
                                                        <span
                                                            className='country-name'>{this.state.selectedConversationCountryData.name}</span>
                                                    </div>
                                                    <div className="prices-container">
                                                        {this.state.messagesCost.inboundMessage !== '' ?
                                                            <span>Inbound message: <span
                                                                className='text-bold'>{this.state.messagesCost.inboundMessage} {this.state.messagesCost.inboundMessage > 1 ? 'credits' : 'credit'}</span></span> : ''}
                                                        {this.state.messagesCost.outboundMessage !== '' ?
                                                            <span>Outbound message: <span
                                                                className='text-bold'>{this.state.messagesCost.outboundMessage} {this.state.messagesCost.outboundMessage > 1 ? 'credits' : 'credit'}</span></span> : ''}
                                                    </div>

                                                </div>

                                                <div className="chat-messages">
                                                    {this.state.selectedConversationFull.map((singleConversation, key) => {
                                                        return (singleConversation.direction === 'incoming' ?

                                                            <div key={key}
                                                                 className='chat-full-conversation'>
                                                                <div
                                                                    className="conversation-date">{singleConversation.created_at_timezone}
                                                                </div>
                                                                <div
                                                                    className="chat-message subscriber-message">
                                                                    {/*<img src="/img/default-user.jpg"*/}
                                                                    {/*     alt="user"/>*/}
                                                                    <span className="message-text">
                                                                                        {singleConversation.message}
                                                                                    </span>
                                                                </div>

                                                            </div>

                                                            : singleConversation.direction === 'outgoing' ? <div
                                                                className="chat-full-conversation">
                                                                <div
                                                                    className="conversation-date">{singleConversation.created_at_timezone}
                                                                </div>
                                                                <div
                                                                    className="chat-message admin-message">
                                                                                        <span
                                                                                            className="message-text">
                                                                                            {singleConversation.message.trim()}
                                                                                        </span>
                                                                </div>
                                                                <div
                                                                    className="chat-sender">Sent
                                                                    by <span
                                                                        className='text-italic'>{singleConversation.from}</span>
                                                                </div>
                                                            </div> : <div
                                                                className="chat-full-conversation">
                                                                <div
                                                                    className="chat-message campaign-message">
                                                                                        <span
                                                                                            className="message-text">

                                                                                            {singleConversation.message}
                                                                                        </span>
                                                                </div>
                                                                <div
                                                                    className="chat-sender">Campaign
                                                                </div>
                                                            </div>)
                                                    })}

                                                    <div ref={(el) => {
                                                        this.messagesEnd = el;
                                                    }}></div>
                                                </div>
                                            </div>

                                            <div className="chat-textarea-container ">
                                                <EmojiTextArea
                                                    uniqueId='sms'
                                                    onUpdate={this.handleSmsFallbackMessage}
                                                    label={'Message'}
                                                    placeholder={'Your SMS message goes here'}
                                                    height={120}
                                                    // maxCharacters={125}
                                                    infoCircleType={'question'}
                                                    infoCircleContent='Message'
                                                    showMessagesNumber={true}
                                                    personalize={true}
                                                    plan={this.state.sourcePlan}
                                                    selectedSource={this.state.selectedSource}
                                                    messageContent={this.state.messageContent}
                                                    cursorPosition={this.state.cursorPosition}
                                                    onClick={this.getCursorPosition}
                                                    sendButton={true}
                                                    sendButtonFunction={this.sendSMSMessage}
                                                    buttonLoading={this.state.loading}
                                                />
                                            </div>

                                        </div>

                                        <div
                                            className={this.state.chatInfoOpen ? "selected-chat-info-panel" : "selected-chat-info-panel hidden"}>
                                            <div className='display-flex justify-content-end full-width'>
                                                <i onClick={this.handleChatInfo}
                                                   className="fas fa-times close-info-panel"></i>
                                            </div>
                                            {/*<img src="img/default-user.jpg" alt="chat-pic"/>*/}
                                            {this.state.selectedConversationContact.name ? <div
                                                    className='info-panel-name'>{this.state.selectedConversationContact.name}</div> :
                                                <div
                                                    className='info-panel-name'>{this.state.selectedConversationContact.phone}</div>}
                                            <div className='info-panel-phone'>
                                                <i className="fas fa-phone"></i>{this.state.selectedConversationContact.phone}
                                            </div>
                                            <div className='info-panel-email'><i
                                                className="far fa-envelope"></i>{this.state.selectedConversationContact.email ? this.state.selectedConversationContact.email : 'No email provided'}
                                            </div>
                                            <div
                                                className='info-panel-email'>{this.state.selectedConversationCountryData ? this.state.selectedConversationCountryData.flag + ' ' + this.state.selectedConversationCountryData.name : ''}

                                            </div>

                                            <p className='margin-top-10 text-light-blue'>Tags</p>
                                            <MultiSelect
                                                items={this.props.tags}
                                                itemRenderer={this.multiMenuItem}
                                                tagInputProps={{
                                                    placeholder: 'Add/remove tags', onRemove: this.handleTagRemove
                                                }}
                                                resetOnSelect={true}
                                                className='tag-multiselect countries-multiselect'
                                                onItemSelect={this.tagSelect}
                                                tagRenderer={this.tagRender}
                                                itemListPredicate={this.filterTags}
                                                selectedItems={this.state.selectedTags}
                                                fill={true}
                                                noResults={<MenuItem disabled={true} text="No results."/>}

                                            />
                                        </div>

                                    </div>}
                            </div>
                            <div
                                className={this.state.selectedConversationNo === '' ? "sms-inbox-container-mobile" : 'sms-inbox-container-mobile chat-selected'}
                            >
                                <div
                                    className={this.state.selectedConversationNo === '' ? "chat-selector-mobile" : 'chat-selector-mobile chat-selected'}>


                                    <div className="chat-selector-menu">
                                        <h1 className='text-center'>Sms Inbox</h1>
                                    </div>
                                    <div className="select-chat">
                                        {Object.keys(smsConversations).map((key, index) => {
                                            return (<div id={key} key={key}
                                                         onClick={() => this.handleSelectChat(smsConversations[key], false)}
                                                         className={`single-chat ${this.state.selectedConversationNo === key ? 'active-chat' : ''}`}
                                            >
                                                <div
                                                    className="display-flex single-chat-info">
                                                    {/*<img*/}

                                                    {/*    src="/img/default-user.jpg"*/}
                                                    {/*    alt="chat-1"/>*/}
                                                    <div
                                                        className="number-preview-container">
                                                        <div
                                                            className="number-date-container ">
                                                                            <span className='text-bold'>
                                                                                {smsConversations[key][0].contact.name && smsConversations[key][0].contact.name !== null && !this.onlySpaces(smsConversations[key][0].contact.name) ? smsConversations[key][0].contact.name : smsConversations[key][0].contact.phone}                                                                    </span>
                                                            <span className="chat-date">
                                                                                {this.props.isoToDate(smsConversations[key][0].created_at)}
                                                                            </span>
                                                        </div>
                                                        <div
                                                            className="chat-excerpt">{smsConversations[key][0].message}</div>
                                                    </div>

                                                </div>
                                            </div>)
                                        })


                                        }


                                    </div>
                                </div>
                                <div
                                    className={this.state.selectedConversationNo === '' ? "messages-panel " : 'messages-panel chat-selected'}>


                                    <div className='fixed-top'>
                                        <div className="messages-panel-settings">
                                            <div className="selected-chat-info">
                                                <i onClick={this.closeChat}
                                                   className="fas fa-chevron-left"></i>
                                                {/*<img src="/img/default-user.jpg" alt="chat-pic"/>*/}
                                                <div className="sms-inbox-name-number">
                                                    {this.state.selectedConversationContact.name ? <span
                                                        className='selected-chat-name text-bold'>{this.state.selectedConversationContact.name}</span> : ''}
                                                    <span
                                                        className='selected-chat-phone text-bold grey-text'>{this.state.selectedConversationContact.phone}</span>
                                                </div>
                                            </div>
                                            <div className="selected-chat-settings">
                                                {/*<i className="far fa-check-circle"></i>*/}
                                                {/*<i className="fas fa-mail-bulk"></i>*/}

                                                {/*<i className="fas fa-ellipsis-v"></i>*/}
                                                <i
                                                    onClick={this.handleChatInfo}
                                                    className=
                                                        {this.state.chatInfoOpen ? "fas fa-info-circle blue-text" : "fas fa-info-circle"}
                                                ></i>

                                            </div>
                                        </div>
                                        <div
                                            className="messages-panel-country display-flex justify-content-space">
                                            <div className="country-container">
                                                        <span
                                                            className='country-flag'>{this.state.selectedConversationCountryData ? this.state.selectedConversationCountryData.flag : ''}</span>
                                                <span
                                                    className='country-name'>{this.state.selectedConversationCountryData ? this.state.selectedConversationCountryData.name : ''}</span>
                                            </div>
                                            <div className="prices-container">
                                                {this.state.messagesCost.inboundMessage !== '' ?
                                                    <span>Inbound message: <span
                                                        className='text-bold'>{this.state.messagesCost.inboundMessage} credits</span></span> : ''}
                                                {this.state.messagesCost.outboundMessage !== '' ?
                                                    <span>Outbound message: <span
                                                        className='text-bold'>{this.state.messagesCost.outboundMessage} credits</span></span> : ''}
                                            </div>

                                        </div>
                                    </div>
                                    <div id='chat-messages-container' className="chat-messages-container">
                                        <div id='chat-messages' className="chat-messages">
                                            {this.state.selectedConversationFull ? this.state.selectedConversationFull.map((singleConversation, key) => {
                                                return (singleConversation.direction === 'incoming' ?

                                                    <div key={key}
                                                         className='chat-full-conversation'>
                                                        <div
                                                            className="conversation-date">{singleConversation.created_at_timezone}
                                                        </div>
                                                        <div
                                                            className="chat-message subscriber-message">
                                                            {/*<img src="/img/default-user.jpg"*/}
                                                            {/*     alt="user"/>*/}
                                                            <span className="message-text">
                                                                                    {singleConversation.message}
                                                                                </span>
                                                        </div>

                                                    </div>

                                                    : singleConversation.direction === 'outgoing' ?
                                                        <div className="chat-full-conversation">
                                                            <div
                                                                className="conversation-date">{singleConversation.created_at_timezone}
                                                            </div>
                                                            <div
                                                                className="chat-message admin-message">
                                                                                    <span className="message-text">
                                                                                        {singleConversation.message.trim()}
                                                                                    </span>
                                                            </div>
                                                            <div className="chat-sender">Sent
                                                                by <span
                                                                    className='text-italic'>{singleConversation.from}</span>
                                                            </div>
                                                        </div> : <div className="chat-full-conversation">
                                                            <div
                                                                className="chat-message campaign-message">
                                                                                    <span className="message-text">
                                                                                        {singleConversation.message}
                                                                                    </span>
                                                            </div>
                                                            <div
                                                                className="chat-sender">Campaign
                                                            </div>
                                                        </div>)
                                            }) : ''}
                                            <div ref={(el) => {
                                                this.messagesMobileEnd = el;
                                            }}></div>
                                        </div>
                                        <div
                                            className={this.state.chatInfoOpen ? "selected-chat-info-panel" : "selected-chat-info-panel hidden"}>
                                            <div className='display-flex justify-content-end full-width'>
                                                <i onClick={this.handleChatInfo}
                                                   className="fas fa-times close-info-panel"></i>
                                            </div>
                                            {/*<img src="img/default-user.jpg" alt="chat-pic"/>*/}
                                            {this.state.selectedConversationContact.name ? <div
                                                    className='info-panel-name'>{this.state.selectedConversationContact.name}</div> :
                                                <div
                                                    className='info-panel-name'>{this.state.selectedConversationContact.phone}</div>

                                            }
                                            <div className='info-panel-phone'><i
                                                className="fas fa-phone"></i>{this.state.selectedConversationContact.phone}
                                            </div>
                                            <div className='info-panel-email'><i
                                                className="far fa-envelope"></i>
                                                {this.state.selectedConversationContact.email ? this.state.selectedConversationContact.email : 'No email provided'}
                                            </div>
                                            <div
                                                className='info-panel-email'>{this.state.selectedConversationCountryData ? this.state.selectedConversationCountryData.flag + ' ' + this.state.selectedConversationCountryData.name : ''}

                                            </div>
                                        </div>
                                    </div>


                                    <div className="chat-textarea-container ">
                                        <EmojiTextArea
                                            uniqueId='sms-mobile'
                                            onUpdate={this.handleSmsFallbackMessage}
                                            label={'Message'}
                                            placeholder={'Your SMS message goes here'}
                                            height={120}
                                            // maxCharacters={125}
                                            infoCircleType={'question'}
                                            infoCircleContent='Message'
                                            showMessagesNumber={true}
                                            personalize={true}
                                            plan={this.state.sourcePlan}
                                            selectedSource={this.state.selectedSource}
                                            messageContent={this.state.messageContent}
                                            cursorPosition={this.state.cursorPosition}
                                            onClick={this.getCursorPosition}
                                            sendButton={true}
                                            sendButtonFunction={this.sendSMSMessage}
                                            buttonLoading={this.state.loading}
                                        />
                                    </div>


                                </div>


                            </div>
                        </React.Fragment>


                    </div>

                    <UpsellModalTailwind
                        showModal={this.state.upgradeModalActive}
                        handleClose={() => this.setState({upgradeModalActive: false})}
                        maxWidth={null}
                        history={this.props.history}
                        title={this.state.upgradeModalTitle}
                        content={this.state.upgradeModalContent}
                        buttonLink={this.state.modalButtonLink}
                        buttonLabel={this.state.modalButtonLabel}
                        plan={this.state.sourcePlan}
                        user={this.props.user}
                        updateUserFromServer={this.props.updateUserFromServer}
                        selectedSource={this.state.selectedSource}
                    />
                    <TopUpModal
                        handleClose={this.closeTopUpModal}
                        showModal={this.state.topUpModalOpen}
                        history={this.props.history}
                    />


                </React.Fragment> : <div className="no-chats">
                    <img src="../img/no-messages.png" alt="no-chats"/>
                    <h2 className='text-bold'>No messages.</h2>
                    <p>Conversation will appear once you get a reply.</p>

                    <Link to='/new/sms'>
                        <button
                            className='btn-action btn-lg margin-top-30'
                        >
                            Start SMS Campaign
                        </button>
                    </Link>
                </div>}
        </React.Fragment>)
    }
}

export default SMSInbox